import React from 'react';

export const SwitchgearCounterOpenIcon = () => (
  <svg
    width="36"
    height="15"
    viewBox="0 0 36 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="-3.99594e-09"
      y1="8.78882"
      x2="12"
      y2="8.78882"
      stroke="#666666"
      strokeWidth="2"
    />
    <line
      x1="11.5528"
      y1="8.89439"
      x2="27.5528"
      y2="0.894391"
      stroke="#666666"
      strokeWidth="2"
    />
    <circle
      cx="12"
      cy="8.37012"
      r="5.5"
      fill="white"
      stroke="#666666"
    />
    <line
      x1="30"
      y1="8.78882"
      x2="36"
      y2="8.78882"
      stroke="#666666"
      strokeWidth="2"
    />
  </svg>
);

export const SwitchgearCounterClosedIcon = () => (
  <svg
    width="36"
    height="12"
    viewBox="0 0 36 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="-3.99594e-09"
      y1="6.4187"
      x2="12"
      y2="6.4187"
      stroke="#666666"
      strokeWidth="2"
    />
    <line
      x1="12"
      y1="6.4187"
      x2="30"
      y2="6.4187"
      stroke="#666666"
      strokeWidth="2"
    />
    <circle
      cx="12"
      cy="6"
      r="5.5"
      fill="#666666"
      stroke="#666666"
    />
    <line
      x1="30"
      y1="6.4187"
      x2="36"
      y2="6.4187"
      stroke="#666666"
      strokeWidth="2"
    />
  </svg>
);
